import DefaultSelect from '@hero/ui-kit/inputs/DefaultSelect';
import Form from '@hero/ui-kit/inputs/Form';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { noop } from 'ts-essentials';
import * as yup from 'yup';

export const actionsSchema = yup
    .object()
    .shape({
        actions: yup.string().nullable().notRequired()
    })
    .defined();

export type ActionsParams = yup.InferType<typeof actionsSchema>;
// PROSPECT_REQUIRES_ACTION | PROSPECT_PROCESSING | PROSPECT_COMPLETED | PROSPECT_FAILED | PENDING_CANCELLATION
const options = [
    {
        label: 'All Actions',
        value: 'ALL'
    },
    {
        label: 'Requires Action',
        value: 'PROSPECT_REQUIRES_ACTION'
    },
    {
        label: 'Processing',
        value: 'PROSPECT_PROCESSING'
    },
    {
        label: 'Completed',
        value: 'PROSPECT_COMPLETED'
    },
    {
        label: 'Failed',
        value: 'PROSPECT_FAILED'
    },
    {
        label: 'Pending Cancellation',
        value: 'PENDING_CANCELLATION'
    }
];

const ProspectActionsFilter: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const actions = searchParams.get('actions')?.toUpperCase();

    return (
        <Form
            validationSchema={actionsSchema}
            submitFn={noop}
            defaultValues={{
                actions: actions ? actions : 'ALL'
            }}
        >
            <DefaultSelect
                styles={{ minWidth: '240px' }}
                name="actions"
                onChange={(e) => {
                    const value = e.currentTarget.value;

                    setSearchParams((prevState) => {
                        if (value === 'all') {
                            prevState.delete('actions');
                        } else {
                            prevState.set('actions', value);
                        }

                        return prevState;
                    });
                }}
                options={options}
            />
        </Form>
    );
};

export default ProspectActionsFilter;
